import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class AuthenticationService {
  apiRoot: string;
  results: object;
  loading: boolean;
  headers = new HttpHeaders({
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {
    this.results = [];
    this.loading = false;
    this.apiRoot = environment.securityAPI;
  }

  public getAnalyticsId(): Observable<any> {
    return this.http.get<any>(this.apiRoot + 'ValidateAnalytics', { headers: this.headers });
  }

  public getAnalyticsToken(data): Observable<any> {
    return this.http.post<any>(this.apiRoot + 'RequestToken', JSON.stringify(data), { headers: this.headers });
  }
}
